import React from 'react';

import IconButton from '@atlaskit/button/icon/button';
import MoreIcon from '@atlaskit/icon/core/show-more-horizontal';
import { Inline } from '@atlaskit/primitives/compiled/inline';

const IconButtonSpacingExample = (): React.JSX.Element => {
	return (
		<Inline space="space.200">
			<IconButton icon={MoreIcon} appearance="primary" label="More actions" />
			<IconButton icon={MoreIcon} appearance="primary" spacing="compact" label="More actions" />
		</Inline>
	);
};

export default IconButtonSpacingExample;
